import type { IconData } from '@stacksjs/iconify-core'

export const airplay: IconData = {
  "body": "<rect width=\"20\" height=\"15\" x=\"2\" y=\"3\" fill=\"currentColor\" opacity=\".5\" rx=\"3\"/><path fill=\"currentColor\" d=\"M16 21H8a1 1 0 0 1-.832-1.555l4-6a1.038 1.038 0 0 1 1.664 0l4 6A1 1 0 0 1 16 21\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default airplay
